import { render } from "./BlFormFieldMulticheckbox.vue?vue&type=template&id=56fce10f&scoped=true"
import script from "./BlFormFieldMulticheckbox.vue?vue&type=script&lang=js"
export * from "./BlFormFieldMulticheckbox.vue?vue&type=script&lang=js"

import "./BlFormFieldMulticheckbox.vue?vue&type=style&index=0&id=56fce10f&scoped=true&lang=css"

import exportComponent from "/tmp/b7562a83-daa0-4796-bff7-c3f4922e39c8/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56fce10f"]])

export default __exports__